module.exports = __webpack_public_path__ + "media/fox-smlr.05def9c5.jpg";